module.exports = __webpack_public_path__ + "static/media/wall.7a8e928a.png";